import React, { Component, Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import halima from '../../asset/image/Halima.jpg';

export class Organizer extends Component {
  render() {
    return (
      <Fragment>
        <Container>
            <Row>
               <Col lg={4} md={6} sm={6} className='p-2'>
               <Row>
                
                    <Col lg={6} md={6} sm={12}>
                    <img className="courseImage"src={halima}></img>

                    </Col>
                   

                    </Row>
                    
                    </Col>
                     <Col lg={6} md={12} sm={12}>
                    <h5 className='text-justify h2Tag'>Halima Syed</h5>
                    <p className='text-justify pTag'> Founder & Lead Organizer – Markham Bazaar With over a decade of experience in event planning, 
                        Halima Syed is a well-recognized name in the Canadian community event space. As the visionary behind
                         Markham Bazaar, Halima has successfully organized and led numerous cultural festivals, shopping expos, 
                         and seasonal markets across the Greater Toronto Area. Her dedication to creating vibrant, inclusive, and memorable experiences has earned her widespread respect among vendors, sponsors, and visitors alike. Known for her meticulous planning, strong community ties, and creative approach, Halima has transformed Markham Bazaar into a trusted platform that celebrates diversity and brings people together.
                        From large-scale Eid Bazaars to seasonal pop-up markets, Halima continues to bridge cultures and foster
                         community spirit through events that reflect the rich multicultural tapestry of Canada.</p>
                   
                    </Col>
            </Row>
        </Container>
      </Fragment>
    )
  }
}

export default Organizer
